<ng-container *transloco="let t; read: 'user'">
  <div id="teacher-survey-modal" class="rounded-lg fix-action-row modal-body">
    <div class="flex justify-between items-start">
      <div>
        <p class="font-semibold pb-1">{{ t('inputRating.teacherSurvey.title') }}</p>
        <p class="mt-1 pb-1">{{ t('inputRating.teacherSurvey.subtitle') }}</p>
      </div>
      @if (!dialogData.viewOnly) {
        <drdp-btn color="save" class="ml-5" type="submit" (click)="onSubmit()">{{ t('inputRating.common.save') }}</drdp-btn>
      }
      @if (dialogData.viewOnly) {
        <i mat-button mat-dialog-close class="text-drdpblue-300 cursor-pointer uil uil-times-circle"></i>
      }
    </div>
    <hr class="w-full">
    <div mat-dialog-content>
      <form [formGroup]="difficultyForm">
        <mat-radio-group formControlName="difficultyLevelId">
          <label class="text-lg required">
            {{ t('inputRating.teacherSurvey.difficultyQuestion') }}
          </label>
          <mat-label>{{ t('inputRating.teacherSurvey.selectDifficultyLevel') }}</mat-label>
          @for (level of difficultyLevels; track level) {
            <div>
              @if (level.isDefault) {
                <mat-radio-button
                  [value]="level.id"
                  color="primary">
                  <!-- Difficulty level names are server-supplied. -->
                  {{level.name}}
                </mat-radio-button>
              }
            </div>
          }
        </mat-radio-group>
        @if (this.dialogData.teacherSurveyReq?.isStructuredPrompt || this.dialogData?.isStructuredPrompt) {
          <mat-radio-group formControlName="extentLevelId">
            <label class="text-lg required">
              {{ t('inputRating.teacherSurvey.structuredPromptQuestion') }}
            </label>
            <mat-label>{{ t('inputRating.teacherSurvey.selectDifficultyLevel') }}</mat-label>
            @for (level of difficultyLevels; track level) {
              <div>
                @if (isPTKMathAndNotDefault(level)) {
                  <mat-radio-button
                    [value]="level.id"
                    color="primary">
                    <!-- Difficulty level names are server-supplied. -->
                    {{level.name}}
                  </mat-radio-button>
                }
              </div>
            }
          </mat-radio-group>
        }

        <label class="text-lg">
          {{ t('inputRating.teacherSurvey.describeDifficulties') }}
        </label>
        <textarea
          formControlName="difficultyAnswer"
          name="difficultyAnswer"
          id="difficultyAnswer"
          class="w-full border border-black rounded-md p-2"
          [placeholder]="t('inputRating.teacherSurvey.answerPlaceholder')"
          >
        </textarea>
      </form>
    </div>
  </div>
</ng-container>
